// src/router.js
import { createRouter, createWebHistory } from "vue-router";
import Home from "./views/Home.vue";
import ModsView from "./views/ModsView.vue";
import ShowcaseView from "./views/ShowcaseView.vue";
import GetawayView from "./views/GetawayView.vue";
import AdminPage from "./views/AdminPage.vue";
import LoginPage from "./views/LoginPage.vue";
import { useAuthStore } from "./stores/authStore";

const routes = [
  { path: "/", component: Home, name: "Home" },
  { path: "/tree", component: ModsView, name: "Mods" },
  { path: "/getaway", component: GetawayView, name: "Blog1" },
  { path: "/showcase", component: ShowcaseView, name: "Blog" },
  {
    path: "/bananas",
    component: AdminPage,
    name: "AdminPage",
    meta: { requiresAuth: true },
  },
  { path: "/login", component: LoginPage, name: "Login" },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Global navigation guard to protect routes requiring authentication.
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  if (to.meta.requiresAuth && !authStore.isLoggedIn) {
    next({ name: "Login" });
  } else {
    next();
  }
});

export default router;
